export default __webpack_public_path__ + "static/topsidemenu02@2x-68a571f55e37422f5a43968a93c90999.png";